<style scoped>
.cls-1 {
  isolation: isolate;
}

.cls-2 {
  fill: #ff3d53;
}

.cls-2, .cls-3 {
  stroke-width: 0px;
}

.cls-3 {
  fill: #1f2631;
}
#Capa_1{
    display: block;
    margin: auto;
}
</style>
<template>
    <div>
        <PageTitle title="Error 404"/>
        <FirstBanner/>
        <section class="padding-vertical-content">
            <div class="container">
                <svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 167 103" width="40%" >
                    <g>
                        <path class="cls-2" d="M52.02,56.22h-7.39v12.98h-17.89v-12.98H0v-13.3L27.89,2.14h16.74v40.55h7.39v13.53h0ZM26.74,42.68v-7.8c0-1.47.05-3.45.16-5.94.11-2.49.19-3.8.25-3.92h-.5c-1.04,2.36-2.22,4.56-3.53,6.61l-7.43,11.06h11.05Z"/>
                        <path class="cls-2" d="M105.18,35.76c0,11.87-1.99,20.56-5.96,26.08-3.98,5.52-10.06,8.28-18.26,8.28s-14.05-2.88-18.12-8.65c-4.07-5.76-6.1-14.34-6.1-25.71,0-11.93,1.99-20.67,5.96-26.24S72.76,1.17,80.96,1.17s14.01,2.9,18.1,8.69c4.08,5.8,6.12,14.43,6.12,25.9ZM74.77,35.76c0,7.58.47,12.8,1.42,15.64s2.54,4.27,4.77,4.27,3.86-1.47,4.79-4.4c.93-2.94,1.4-8.1,1.4-15.51s-.47-12.64-1.42-15.62-2.54-4.47-4.77-4.47-3.82,1.44-4.77,4.31c-.95,2.87-1.42,8.13-1.42,15.78Z"/>
                        <path class="cls-2" d="M162.11,56.22h-7.38v12.98h-17.89v-12.98h-26.75v-13.3L137.98,2.14h16.74v40.55h7.38v13.53h0ZM136.84,42.68v-7.8c0-1.47.05-3.45.16-5.94.11-2.49.19-3.8.25-3.92h-.5c-1.04,2.36-2.22,4.56-3.53,6.61l-7.43,11.06h11.05Z"/>
                    </g>
                    <g>
                        <path class="cls-3" d="M49.02,69.86h-19.73v-12.98H2.55v-14.51L30.88.95h18.15v40.55h7.39v15.37h-7.39v12.99h-.01ZM31.13,68.02h16.05v-12.98h7.39v-11.69h-7.39V2.79h-15.34L4.39,42.94v12.1h26.74v12.98ZM31.13,43.35h-13.7l8.4-12.49c1.27-1.98,2.44-4.16,3.45-6.46l.24-.55h2.6l-.62,1.23c-.03.23-.1,1.02-.21,3.65-.11,2.45-.16,4.44-.16,5.9,0,0,0,8.72,0,8.72ZM20.88,41.51h8.41v-6.88c0-1.49.05-3.5.16-5.98.01-.14.01-.28.02-.41-.66,1.26-1.37,2.48-2.11,3.63l-6.48,9.64Z"/>
                        <path class="cls-3" d="M84.43,70.78c-8.29,0-14.64-3.04-18.87-9.04-4.16-5.9-6.27-14.72-6.27-26.24s2.06-21.07,6.13-26.77c4.14-5.8,10.53-8.73,19.01-8.73s14.6,3.06,18.85,9.08c4.17,5.93,6.29,14.82,6.29,26.43s-2.06,20.96-6.14,26.62c-4.13,5.73-10.52,8.65-19,8.65ZM84.43,1.83c-7.84,0-13.73,2.68-17.51,7.96-3.84,5.38-5.79,14.03-5.79,25.7s2,19.6,5.93,25.18c3.92,5.56,9.6,8.26,17.37,8.26s13.74-2.66,17.51-7.9c3.84-5.34,5.79-13.93,5.79-25.54s-2-19.76-5.96-25.37c-3.93-5.57-9.6-8.29-17.34-8.29ZM84.43,56.33c-1.83,0-4.3-.85-5.64-4.9-.99-2.96-1.47-8.18-1.47-15.93s.48-13.07,1.47-16.07c1.35-4.09,3.81-4.94,5.64-4.94,2.67,0,4.57,1.72,5.65,5.11.99,3.1,1.46,8.3,1.46,15.9s-.47,12.73-1.44,15.78c-1.32,4.17-3.81,5.05-5.67,5.05ZM84.43,16.33c-1.81,0-3.08,1.2-3.9,3.68-.91,2.77-1.38,7.98-1.38,15.49s.46,12.62,1.37,15.35c.82,2.45,2.09,3.64,3.9,3.64s3.11-1.23,3.92-3.76c.9-2.83,1.36-7.95,1.36-15.23s-.46-12.46-1.38-15.34c-.81-2.58-2.08-3.83-3.89-3.83Z"/>
                        <path class="cls-3" d="M159.12,69.86h-19.73v-12.98h-26.74v-14.51L140.98.95h18.15v40.55h7.39v15.37h-7.39v12.99h0ZM141.23,68.02h16.05v-12.98h7.39v-11.69h-7.39V2.79h-15.34l-27.46,40.15v12.1h26.74v12.98h0ZM141.23,43.35h-13.7l8.4-12.49c1.28-1.99,2.44-4.17,3.45-6.46l.24-.55h2.6l-.62,1.23c-.03.23-.1,1.02-.21,3.65-.11,2.45-.16,4.44-.16,5.9v8.72ZM130.98,41.51h8.41v-6.88c0-1.49.05-3.5.16-5.98,0-.14,0-.28.02-.41-.66,1.26-1.36,2.48-2.11,3.64l-6.48,9.63Z"/>
                    </g>
                    <g class="cls-1">
                        <path class="cls-3" d="M49.49,98.33l3.29-15.56h11.02l-.5,2.35h-8.21l-.86,4.17h7.39l-.46,2.18h-7.39l-.98,4.52h8.29l-.48,2.35h-11.11Z"/>
                        <path class="cls-3" d="M63.13,98.33l3.29-15.56h6.58c3.83,0,5.51,1.59,4.88,4.52l-.04.25c-.44,1.93-1.91,3.31-3.87,3.69l-.02.08c1.42.36,1.97,1.38,1.86,3.2l-.1,1.51c-.06,1.05,0,1.76.17,2.3h-2.87c-.1-.46-.15-1.15-.08-2.41l.04-1.51c.06-1.24-.61-1.89-2.62-1.89h-3.16l-1.24,5.8h-2.82v.02ZM67.65,90.2h3.69c1.89,0,3.25-.69,3.67-2.66l.06-.25c.27-1.38-.46-2.18-2.43-2.18h-3.92l-1.07,5.09Z"/>
                        <path class="cls-3" d="M78.42,98.33l3.29-15.56h6.58c3.83,0,5.51,1.59,4.88,4.52l-.04.25c-.44,1.93-1.91,3.31-3.87,3.69l-.02.08c1.42.36,1.97,1.38,1.86,3.2l-.11,1.51c-.06,1.05,0,1.76.17,2.3h-2.87c-.1-.46-.15-1.15-.08-2.41l.04-1.51c.06-1.24-.61-1.89-2.62-1.89h-3.16l-1.24,5.8h-2.81v.02ZM82.94,90.2h3.69c1.89,0,3.25-.69,3.67-2.66l.06-.25c.27-1.38-.46-2.18-2.43-2.18h-3.92l-1.07,5.09Z"/>
                        <path class="cls-3" d="M94.44,90.74l.1-.46c1.21-5.38,3.98-7.81,8.65-7.81s6.95,2.74,5.7,8l-.04.17c-1.34,5.53-3.9,8-8.52,8-4.36,0-7.12-2.45-5.89-7.9ZM105.98,90.77l.08-.31c.94-4.19-.59-5.57-3.31-5.57s-4.5,1.36-5.36,5.28l-.13.61c-.9,4.06.75,5.47,3.16,5.47,2.73-.02,4.64-1.44,5.56-5.48Z"/>
                        <path class="cls-3" d="M110.07,98.33l3.29-15.56h6.58c3.83,0,5.51,1.59,4.88,4.52l-.04.25c-.44,1.93-1.91,3.31-3.87,3.69l-.02.08c1.42.36,1.97,1.38,1.86,3.2l-.11,1.51c-.06,1.05,0,1.76.17,2.3h-2.87c-.1-.46-.15-1.15-.08-2.41l.04-1.51c.06-1.24-.61-1.89-2.62-1.89h-3.16l-1.24,5.8h-2.81v.02ZM114.59,90.2h3.69c1.89,0,3.25-.69,3.67-2.66l.06-.25c.27-1.38-.46-2.18-2.43-2.18h-3.92l-1.07,5.09Z"/>
                    </g>
                    <path class="cls-3" d="M158.93,103.28H4.73c-.38,0-.68-.3-.68-.68v-24.28c0-.38.31-.68.68-.68h154.2c.38,0,.68.3.68.68v24.28c0,.38-.31.68-.68.68ZM5.41,101.92h152.84v-22.91H5.41v22.91Z"/>
                </svg>
            </div>
            <div>
                <p style="margin:30px" class="align-items-lg-center align-items-center justify-content-between text-center"><strong>{{ $t('general.pagina_no_encontrada') }}</strong></p>
            </div>
            <li style="list-style: none; margin: 50px" class="align-items-lg-center align-items-center justify-content-between text-center">
                <div>
                    <button class="btn" @click="home()">{{ $t('gracias.volver') }}</button>
                </div>
            </li>
        </section>
    </div>
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import FirstBanner from '@/components/frontend/shared/FirstBanner';
    import { useHead } from '@/composables/common/seo/useHead';

    export default {
        data() {
            return {
            }
        },
        created() {
            useHead('Error 404');
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        components: {
            PageTitle, FirstBanner
        },
        methods: {
            home() {
                this.$router.push({ name: 'front.home' });
            }
        }
    }
</script>